import {
  GET_CLAIMS_API_REQUEST,
  GET_CLAIMS_API_SUCCESS,
  GET_CLAIMS_API_ERROR,
  GET_NEXT_CLAIMS_SUCCESS,
  UPDATE_CLAIMS_CURRENT_CACHE_KEY,
} from '../../../constants/claimActionNames';
import { agentType } from '../../../utils/variables';
import { checkCacheValid, generateCacheKey } from '../../../utils/functions/cache';
import { getClaimsUrl } from '../../../apis/claims/getClaimsApi';
import { getClaimsApi } from '../../../apis/claims';
// import { getPayloadResponse } from '../../../reducers/claims';

function updateCacheKey(cacheKey) {
  return {
    type: UPDATE_CLAIMS_CURRENT_CACHE_KEY,
    payload: cacheKey,
  };
}

function getClaimsRequest(body) {
  return {
    type: GET_CLAIMS_API_REQUEST,
    payload: true,
    body,
  };
}

function getClaimsSuccess(claims, body, cacheKey, lobTypes) {
  return {
    type: GET_CLAIMS_API_SUCCESS,
    payload: claims,
    body,
    lobTypes,
    cacheKey,
  };
}

function getClaimsError(err, body) {
  return {
    type: GET_CLAIMS_API_ERROR,
    payload: err,
    body,
  };
}

export function getClaimsAction(params, body) {
  // console.log('body: ', body);
  // console.log('params: ', params);
  // const response = getPayloadResponse();
  return (dispatch, getState) => {
    const state = getState();
    const lobTypes = state?.locations?.lobCategories;
    const usertype = state?.auth?.usertype;
    let filteredLobCategories = [];
    if (usertype === agentType) {
      filteredLobCategories = lobTypes.filter(x => x.isAvailableForAgentClaims);
    } else {
      filteredLobCategories = lobTypes.filter(x => x.isAvailableForCustomerClaims);
    }

    const cacheParams = {
      ...params,
      infiniteScroll: body?.infiniteScroll,
      alpha2: body?.alpha2,
    };

    const cacheKey = generateCacheKey({
      path: getClaimsUrl,
      cacheParams,
      state,
    });

    const { isCacheValid, cache } = checkCacheValid(getState, 'claims', cacheKey);
    // console.log('isCacheValid: ', isCacheValid);

    if (isCacheValid) {
      // dispatch(getClaimsSuccess(null, params, cacheKey, filteredLobCategories));
      dispatch(updateCacheKey(cacheKey));
      dispatch(getClaimsSuccess(cache, body, cacheKey, filteredLobCategories));
      return Promise.resolve(cache);
    }

    // console.log('filteredLobCategories: ', filteredLobCategories);
    dispatch(getClaimsRequest(body));
    return getClaimsApi
      .getClaims(state, params, body.usertype)
      .then(data => {
        dispatch(getClaimsSuccess(data, body, cacheKey, filteredLobCategories));
        return data;
      })
      .catch(error => {
        dispatch(getClaimsError(error, body));
        throw error;
      });
  };
}

function getNextClaimsSuccess(prod) {
  return {
    type: GET_NEXT_CLAIMS_SUCCESS,
    payload: prod,
  };
}

export function getNextClaimsAction(data) {
  return getNextClaimsSuccess(data);
}

export default { getClaimsAction, getNextClaimsAction };
